import lrViewTable from './_src/lrViewTable.vue'
lrViewTable.install = function(Vue) {
  Vue.component(lrViewTable.name, lrViewTable)
}
export default lrViewTable